<template>
  <div
    id="divSLContainer"
    v-on:click="exitmenu"
    class="page-effect remove-space"
    :style="'background-color: #f1f3f4; overflow:hidden; ' + getHeight()"
  >
    <section id="sectionId" class="d-flex body-content pt-0 " style="width: 100%">
      <div style="position: relative; width: 100%">
        <div class="speaker-lounge-hld">
          <div class="lounge-custome-container">
            <div class="speaker-guide-btn">
              <a
                style="
                  display: inline-block;
                  height: 100%;
                  width: 100%;
                  color: #fff;
                "
                href="https://docs.google.com/presentation/d/1hyuFuHYAo3_EaXSSqZ66rkB_z8sAA-QC/edit#slide=id.p1"
                target="_blank"
              >
                <span class="mr-3"
                  ><img
                    src="../assets/Images/speaker-guide.png"
                    style="height: 25px; width: 25px"
                /></span>
                View Speaker Guide
              </a>
            </div>
            <div class="lounge-head">
              <div class="speaker-lounge-left">
                <h4>{{ $t("menu.speakersLounge") }}</h4>
                <h2>{{ fullName }}</h2>
              </div>
              <!-- <div class="speaker-lounge-right">
                <ul>
                  <li>
                    <a href=""> <span></span> Notification </a>
                  </li>
                  <li>
                    <a href=""> <span></span> My Profile </a>
                  </li>
                  <li>
                    <a href=""> <span></span> Event Lobby </a>
                  </li>
                </ul>
              </div> -->
              <div class="lounge-session-list-wrap">
                <h3>JOIN SESSION(S)</h3>
                <div
                  class="lounge-session-wrap"
                  style="
                    max-height: 650px;
                    overflow-y: auto;
                    padding-right: 5px;
                  "
                >
                  <div
                    v-for="session in myAgenda"
                    :key="session.SessionId"
                    class="single-lounge-session"
                    :data-val="session.SessionId"
                  >
                    <div class="lounge-session-left">
                      <div class="lounge-session-time">
                        <p>
                          {{ session.StartTimeLabel }} -
                          {{ session.EndTimeLabel }}
                        </p>
                      </div>
                      <div
                        class="
                          d-md-flex
                          justify-content-between
                          align-items-center
                        "
                        style="width: 100%"
                      >
                        <div class="lounge-session-details">
                          <span
                            v-if="correntTimeMS >= session.EndTimestamp"
                            class="lounge-session-status end"
                            >Ended</span
                          >
                          <span
                            v-if="
                              correntTimeMS > session.StartTimestamp &&
                              correntTimeMS < session.EndTimestamp
                            "
                            class="lounge-session-status live"
                            >Live</span
                          >
                          <span
                            v-if="correntTimeMS < session.StartTimestamp"
                            class="lounge-session-status upcoming"
                            >Upcoming</span
                          >
                          <h5 v-html="session.Name"></h5>
                        </div>
                        <div
                          v-if="session.SessionTypeDetails.TypeID == 1"
                          class="lounge-session-action"
                        >
                          <button
                            v-if="correntTimeMS < session.StartTimestamp"
                            class="disabled"
                          >
                            Watch Now
                          </button>
                          <button
                            v-else
                            @click="onStartSession(session.SessionId)"
                          >
                            Watch Now
                          </button>
                        </div>

                        <div
                          v-if="session.SessionTypeDetails.TypeID == 2"
                          class="lounge-session-action"
                        >
                          <button
                            v-if="
                              correntTimeMS > session.StartTimestamp &&
                              correntTimeMS < session.EndTimestamp
                            "
                            @click="onStartSession(session.SessionId)"
                          >
                            Watch Now
                          </button>
                          <button v-else class="disabled">Watch Now</button>
                        </div>
                        <div
                          v-if="session.SessionTypeDetails.TypeID == 3"
                          class="lounge-session-action"
                        >
                          <button
                            v-if="
                              correntTimeMS > session.StartTimestamp &&
                              correntTimeMS < session.EndTimestamp
                            "
                            @click="onStartSession(session.SessionId)"
                          >
                            Join Now
                          </button>
                          <button
                            v-else-if="
                              correntTimeMS < session.StartTimestamp &&
                              session.IsSpeaker
                            "
                            @click="onStartSession(session.SessionId)"
                          >
                            ENTER BACKSTAGE
                          </button>
                          <button v-else class="disabled">Join Now</button>
                        </div>
                        <div
                          v-if="session.SessionTypeDetails.TypeID == 4"
                          class="lounge-session-action"
                        >
                          <button
                            v-if="
                              correntTimeMS > session.StartTimestamp &&
                              correntTimeMS < session.EndTimestamp
                            "
                            @click="onStartSession(session.SessionId)"
                          >
                            Watch Now
                          </button>
                          <button v-else class="disabled">Watch Now</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <v-dialog
      v-model="rtmpDialog.state"
      persistent
      transition="dialog-bottom-transition"
      width="800"
    >
      <rtmpComponent
        :key="rtmpDialog.key"
        ref="rtmpComponent"
        v-bind:rtmpOptions="rtmpDialog.rtmpOptions"
        @rtmpActions="rtmpActions"
      />
    </v-dialog>
    <div
      id="RetryJoinInZoom"
      class="modal fade"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document" style="max-width: 400px">
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>

            <div class="retry-modal p-4">
              <p style="font-size: 20px; font-weight: 600; color: #1e1f26">
                Please try again.
              </p>
              <div>
                <a
                  href="javascript:void(0)"
                  class="button-no"
                  @click="cancelRetryJoinInZoom"
                  >Cancel</a
                >
                <a
                  href="javascript:void(0)"
                  class="button-yes"
                  @click="retryJoinInZoom"
                  >Retry</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import Vue from "vue";
import jQuery from "jquery";
let $ = jQuery;
import db from "../components/firebaseInit";
//import store from "../store";
//import { bus } from "@/main";
import router from "../router";
import APIs from "../components/APIInit";
import axios from "axios";
import common from "@/common";
import rtmpComponent from "@/components/RTMPComponent.vue";

var zoomRTMPRefreshTimer;
var ZoomRTMPParticipantsListener;
let vm;
export default {
  components: {
    rtmpComponent,
  },
  data() {
    return {
      rtmpDialog: {
        key: 0,
        lastUpdateTimeStamp: 0,
        sessionId: "",
        session: null,

        rtmpOptions: {
          title: "Welcome",
          state: false,
          startProcessing: false,
          stopProcessing: false,
          sessionId: "",
          uid: "",
          event_collectionName: "",

          hasZoomLink: false,
          rtmpStartLink: false,
          rtmpStopLink: false,
          rtmpAudienceLink: false,
          viewersCount: 0,
          zoomUrl: "",
          streamUrl: "",
          ZoomMeetingStarted: false,
          ZoomRTMPStarted: false,
          chatEnabled: false,
          qnaEnabled: false,
          //attendeeEnabled: false,
        },
      },
      correntTimeMS: new Date().getTime(),
      uid: "",
      email: "",
      firstName: "",
      lastName: "",
      fullName: "",
      company: "",
      country: "",
      designation: "",
      profilePictureURL: "",
      event_collectionName: "",
      eventName: "",
      pageUrl: "",
      headerText: this.$t("menu.speakersLounge"),
      loading: true,
      myAgenda: [],
    };
  },
  computed: {
    rtmpComponent() {
      return vm.$refs.rtmpComponent.rtmpComp;
    },
    sessionStatus(startTime, endTime) {
      var result = -1;
      var currentTime = parseInt(new Date().getTime() / 1000);
      if (currentTime > endTime) {
        result = -1;
      } else if (currentTime < startTime) {
        result = 1;
      } else if (currentTime > startTime && currentTime < endTime) {
        result = 0;
      }
      return result;
    },
  },
  watch: {
    "rtmpDialog.lastUpdateTimeStamp"() {
      if (vm.rtmpDialog.session) {
        let session = vm.rtmpDialog.session;
        vm.rtmpDialog.rtmpOptions.hasZoomLink = false;
        vm.rtmpDialog.rtmpOptions.rtmpStartLink = false;
        vm.rtmpDialog.rtmpOptions.rtmpStopLink = false;
        vm.rtmpDialog.rtmpOptions.rtmpAudienceLink = false;
        vm.rtmpDialog.rtmpOptions.ZoomMeetingStarted =
          session.ZoomMeetingStarted;
        vm.rtmpDialog.rtmpOptions.ZoomRTMPStarted = session.ZoomRTMPStarted;
        if (session.IsZoomRTMP) {
          if (session.IsHost || session.IsSpeaker) {
            vm.rtmpDialog.rtmpOptions.hasZoomLink = true;
          }
          if (session.IsHost) {
            vm.rtmpDialog.rtmpOptions.rtmpStartLink = true;
          }
          if (session.IsHost && session.ZoomRTMPStarted) {
            vm.rtmpDialog.rtmpOptions.rtmpStopLink = true;
          }
          if (session.ZoomRTMPStarted) {
            vm.rtmpDialog.rtmpOptions.rtmpAudienceLink = true;
          }
        }
      }
    },
  },
  //beforeRouteUpdate(to, from, next) {
  //  next(true);
  //  let pageUrl = vm.$route.params.name;
  //  vm.renderPage(pageUrl);
  //},
  beforeUpdate() {
    //alert("beforeUpdate");
  },
  updated() {
    //
  },
  created() {
    vm = this;
    vm.uid = vm.getSessionUserId();
    vm.event_collectionName = vm.getEventCollectionName();
    vm.eventName = vm.getEventName();
    document.title = vm.headerText + " - " + vm.eventName;
    var user = vm.getSessionUser();
    vm.email = user.Email;
    vm.firstName = user.fname;
    vm.lastName = user.lname;
    vm.fullName = user.name;
    vm.company = user.company;
    vm.designation = user.title;
    vm.profilePictureURL = vm.getCDNUrl(user.profilepic);
    setInterval(function () {
      vm.correntTimeMS = parseInt(new Date().getTime() / 1000);
      vm.setMyAgendaDiplayOrder();
    }, 1000);
  },
  async mounted() {
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    if ($("#btnAddUserView")) {
      $("#btnAddUserView").click();
    }
    if ($("#imgBanner")) {
      $("#imgBanner").attr("src", obj.EventBranding[0].banner);
    }
    common.toggleTopMenu(true);
    common.toggleLeftMenu(true);

    //if ($("#topmenu")) {
    //  $("#topmenu").show();
    //}

    let result = await vm.getSpeakersSessionCount(vm.uid);
    if (result && result.status == 0) {
      if (result.data) {
        vm.myAgenda = result.data;
        vm.myAgenda.forEach((session) => {
          //session.StartTimeLabel = common.getFormattedTime(
          //  session.StartTimestamp
          //);
          //session.EndTimeLabel = common.getFormattedTime(session.EndTimestamp);
          session.StartTimeLabel = common.getFormattedDateTime(
            session.StartTimestamp
          );
          session.EndTimeLabel = common.getFormattedDateTime(
            session.EndTimestamp
          );
        });
      }
    }
  },
  beforeDestroy() {
    if (zoomRTMPRefreshTimer) {
      clearInterval(zoomRTMPRefreshTimer);
    }
    if (ZoomRTMPParticipantsListener) {
      ZoomRTMPParticipantsListener();
      ZoomRTMPParticipantsListener = null;
    }
  },
  methods: {
    exitmenu: function () {
      $(".tab-content-one .tab-pane").removeClass("active");
      $(".nav-link.tab-link").removeClass("active");
    },
    getHeight() {
      return common.getHeaderHeight();
    },
    setMyAgendaDiplayOrder() {
      debugger;
      var result1 = vm.myAgenda.filter(function (session) {
        return vm.correntTimeMS < session.EndTimestamp;
      });
      var result2 = vm.myAgenda.filter(function (session) {
        return vm.correntTimeMS >= session.EndTimestamp;
      });
      //alert("result1: " + result1.length);
      //alert("result2: " + result2.length);

      result1 = result1.sort(function (a, b) {
        let v1 = a.StartTimestamp;
        let v2 = b.StartTimestamp;
        return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
      });
      result2 = result2.sort(function (a, b) {
        let v1 = a.StartTimestamp;
        let v2 = b.StartTimestamp;
        return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
      });
      vm.myAgenda = result1.concat(result2);
    },
    onStartSession(sessionId) {
      $(".tooltip").tooltip("hide");
      $(".modal").modal("hide");
      vm.myAgenda.forEach(function (session) {
        if (session.SessionId == sessionId) {
          if (session.SessionTypeDetails.TypeID == 1) {
            vm.goForInternalPlayer(session.SessionId);
          } else if (session.SessionTypeDetails.TypeID == 2) {
            vm.goForInternalPlayer(session.SessionId);
          } else if (session.SessionTypeDetails.TypeID == 3) {
            vm.startSession(session);
          } else if (session.SessionTypeDetails.TypeID == 4) {
            router.push({
              path: "/roundtable/" + sessionId,
            });
          } else if (session.SessionTypeDetails.TypeID == 5) {
            if (session.InPersonURL) {
              if (session.InPersonURL.startsWith("/")) {
                router.push(session.InPersonURL);
              } else {
                vm.goForExternalPlayer(session.InPersonURL);
              }
            } else {
              vm.goForInternalPlayer(session.SessionId);
            }
          }
        }
      });
    },
    startSession: function (session) {
      if (session.StreamingClient == "Zoom") {
        vm.tempSession = session;
        if (session.IsHost) {
          if (session.IsZoomRTMP) {
            vm.rtmpActions(0, session.SessionId);
          } else {
            vm.goForExternalPlayer(session.Zoom_Detail.start_url);
          }
        } else if (session.IsSpeaker) {
          if (session.IsZoomRTMP) {
            vm.rtmpActions(0, session.SessionId);
          } else {
            vm.showLoader();
            let headers = {
              Authorization: "Bearer " + self.getSessionToken(),
              "content-type": "application/json",
            };
            let requestData = {
              email: vm.email,
              first_name: vm.firstName,
              last_name: vm.lastName,
              webinarid: session.Zoom_Detail.id,
            };
            axios
              .post(APIs.AddAttendeesToZoom, requestData, {
                headers: headers,
              })
              .then((response) => {
                if (
                  response &&
                  response.data &&
                  response.data.status == 0 &&
                  response.data.data.id &&
                  response.data.data.join_url &&
                  response.data.data.join_url != ""
                ) {
                  window.open(response.data.data.join_url, "_blank");
                  self.postLeaderboardAction("SNVW");
                  //let headers = {
                  //  Authorization: "Bearer " + self.getSessionToken(),
                  //  "content-type": "application/json",
                  //};
                  //let requestData = {
                  //  email: vm.email,
                  //  name: vm.firstName + " " + vm.lastName,
                  //  webinarid: session.Zoom_Detail.id,
                  //};
                  //axios
                  //  .post(APIs.AddSpeakersToZoom, requestData, {
                  //    headers: headers,
                  //  })
                  //  .then((response1) => {
                  //    vm.hideLoader();
                  //    if (response1.data && response1.data.id) {
                  //      vm.goForExternalPlayer(response.data.join_url);
                  //    } else {
                  //      vm.retryJoinInZoomPopup();
                  //    }
                  //  })
                  //  .catch((error) => {
                  //    vm.hideLoader();
                  //    console.log(error);
                  //    vm.retryJoinInZoomPopup();
                  //  });
                } else {
                  vm.hideLoader();
                  vm.retryJoinInZoomPopup();
                }
              })
              .catch((error) => {
                vm.hideLoader();
                console.log(error);
                vm.retryJoinInZoomPopup();
              });
          }
        } else {
          if (session.IsZoomRTMP) {
            vm.goForInternalPlayer(session.SessionId);
          } else {
            let headers = {
              Authorization: "Bearer " + self.getSessionToken(),
              "content-type": "application/json",
            };
            let requestData = {
              email: vm.email,
              first_name: vm.firstName,
              last_name: vm.lastName,
              webinarid: session.Zoom_Detail.id,
            };
            axios
              .post(APIs.AddAttendeesToZoom, requestData, {
                headers: headers,
              })
              .then((response) => {
                if (
                  response.data &&
                  response.data.join_url &&
                  response.data.join_url != ""
                ) {
                  vm.goForExternalPlayer(response.data.join_url);
                } else {
                  vm.retryJoinInZoomPopup();
                }
              })
              .catch((error) => {
                console.log(error);
                vm.retryJoinInZoomPopup();
              });
          }
        }
      } else {
        vm.goForInternalPlayer(session.SessionId);
      }
    },
    goForInternalPlayer: function (sessionId) {
      // var obj = JSON.parse(window.localStorage.getItem("my-app"));
      // if (
      //   screen.width < 767 &&
      //   obj.AgoraPlayerBrowserSupportInMobile == false
      // ) {
      //   router.push("/screeninfo");
      // } else if (
      //   screen.width >= 768 &&
      //   screen.width <= 1024 &&
      //   obj.AgoraPlayerBrowserSupportInIPad == false
      // ) {
      //   router.push("/screeninfo");
      // } else {
        router.push({
          path: "/livestage/" + sessionId,
        });
      // }
    },
    goForExternalPlayer: function (externalLink) {
      if (externalLink) {
        window.open(externalLink, "_blank");
      }
    },
    retryJoinInZoomPopup() {
      $("#RetryJoinInZoom").modal(
        {
          backdrop: "static",
        },
        "show"
      );
    },
    cancelRetryJoinInZoom() {
      $("#RetryJoinInZoom").modal("hide");
    },
    retryJoinInZoom() {
      $("#RetryJoinInZoom").modal("hide");
      if (vm.tempSession) {
        vm.goForGreenRoom(vm.tempSession);
      }
    },
    StartRTMPStreaming(sessionId, e) {
      $("#session_wrap_" + sessionId + " .on-demand-dropdown").addClass(
        "d-none"
      );
      vm.myAgenda.forEach(function (session) {
        if (session.SessionId == sessionId) {
          if (session.SessionTypeDetails.TypeID == 3) {
            let headers = {
              "content-type": "application/json",
            };
            let bodyData = {
              meetingid: session.Zoom_Detail.id,
              stream_url: session.ZoomRTMPMUX_detail.data.rtmpPushEndpoint.url,
              stream_key:
                session.ZoomRTMPMUX_detail.data.rtmpPushEndpoint.streamKey,
              page_url: session.ZoomRTMPMUX_detail.data.playbackUrl,
            };
            vm.showLoader();
            axios
              .post(APIs.EnableZoomRTMPStreaming, bodyData, {
                headers: headers,
              })
              .then((response) => {
                vm.hideLoader();
                console.log(response.data);
                if (response.data.code == 1) {
                  db.collection(vm.event_collectionName)
                    .doc("SessionList")
                    .collection("Sessions")
                    .doc(sessionId)
                    .update({
                      ZoomRTMPEnable_Status: response.data,
                      ZoomRTMPStarted: true,
                    })
                    .then(function () {
                      //resolve(response.data);
                      $(
                        "#session_wrap_" + sessionId + " .on-demand-dropdown"
                      ).addClass("d-none");
                      vm.showSnackbar(
                        "RTMP Streaming started successfully.",
                        "info",
                        "top"
                      );
                    })
                    .catch(function (error) {
                      //$(
                      //  "#session_wrap_" + sessionId + " .on-demand-dropdown"
                      //).addClass("d-none");
                      console.error(
                        "Error updating ZoomRTMPEnable_Status: ",
                        error
                      );
                      vm.showSnackbar(
                        "Error on Start RTMP Streaming.",
                        "error",
                        "top"
                      );
                    });
                } else {
                  console.log(response);
                  vm.showSnackbar(
                    "Error on Start RTMP Streaming.",
                    "error",
                    "top"
                  );
                }
              })
              .catch((error) => {
                vm.hideLoader();
                console.log(error);
                vm.showSnackbar(
                  "Error on Start RTMP Streaming.",
                  "error",
                  "top"
                );
              });
          }
        }
      });
      if (e) {
        e.stopPropagation();
      }
    },
    StopRTMPStreaming(sessionId, e) {
      $("#session_wrap_" + sessionId + " .on-demand-dropdown").addClass(
        "d-none"
      );
      vm.myAgenda.forEach(function (session) {
        if (session.SessionId == sessionId) {
          if (session.SessionTypeDetails.TypeID == 3) {
            let headers = {
              "content-type": "application/json",
            };
            let bodyData = {
              meetingid: session.Zoom_Detail.id,
            };
            vm.showLoader();
            axios
              .post(APIs.DisableZoomRTMPStreaming, bodyData, {
                headers: headers,
              })
              .then((response) => {
                vm.hideLoader();
                console.log(response.data);
                if (response.data.code == 1) {
                  db.collection(vm.event_collectionName)
                    .doc("SessionList")
                    .collection("Sessions")
                    .doc(sessionId)
                    .update({
                      ZoomRTMPEnable_Status: response.data,
                      ZoomRTMPStarted: false,
                    })
                    .then(function () {
                      //resolve(response.data);
                      $(
                        "#session_wrap_" + sessionId + " .on-demand-dropdown"
                      ).addClass("d-none");
                      vm.showSnackbar(
                        "RTMP Streaming stopped successfully.",
                        "info",
                        "top"
                      );
                    })
                    .catch(function (error) {
                      //$(
                      //  "#session_wrap_" + sessionId + " .on-demand-dropdown"
                      //).addClass("d-none");
                      console.error(
                        "Error updating ZoomRTMPEnable_Status: ",
                        error
                      );
                      vm.showSnackbar(
                        "Error on Stop RTMP Streaming.",
                        "error",
                        "top"
                      );
                    });
                } else {
                  console.log(response);
                  vm.showSnackbar(
                    "Error on Stop RTMP Streaming.",
                    "error",
                    "top"
                  );
                }
              })
              .catch((error) => {
                vm.hideLoader();
                console.log(error);
                vm.showSnackbar(
                  "Error on Stop RTMP Streaming.",
                  "error",
                  "top"
                );
              });
          }
        }
      });
      if (e) {
        e.stopPropagation();
      }
    },
    ZoomRTMPStatusListener(objSession) {
      debugger;
      if (!objSession.ZoomRTMPListener) {
        objSession.ZoomRTMPListener = db
          .collection(vm.event_collectionName)
          .doc("SessionList")
          .collection("Sessions")
          .doc(objSession.SessionId)
          .onSnapshot((doc) => {
            var data = doc.data();
            objSession.ZoomRTMPStarted = data.ZoomRTMPStarted
              ? data.ZoomRTMPStarted
              : false;
            objSession.ZoomMeetingStarted = data.MeetingStarted
              ? data.MeetingStarted
              : false;
            //alert(objSession.ZoomRTMPStarted);
            //if (!objSession.ZoomRTMPStarted) {
            //  objSession.IsLive = false;

            //  objSession.LinkClass = "upcoming-status new-btn-design-disabled";
            //  objSession.StatusDisplayText = vm.$t("livestage.upcoming");
            //  objSession.StatusClass = "upcoming-session";
            //}
            if (objSession.SessionId == vm.rtmpDialog.sessionId) {
              vm.rtmpDialog.session = objSession;
              vm.rtmpDialog.lastUpdateTimeStamp = new Date().getTime();
            }
          });
      }
    },
    rtmpActions(action, sessionId) {
      let flag = true;
      if (action == 0) {
        vm.rtmpDialog.key += 1;
        vm.rtmpDialog.sessionId = "";
        vm.rtmpDialog.session = null;
        vm.rtmpDialog.rtmpOptions.sessionId = "";
        vm.rtmpDialog.rtmpOptions.session = null;
        vm.rtmpDialog.rtmpOptions.hasZoomLink = false;
        vm.rtmpDialog.rtmpOptions.rtmpStartLink = false;
        vm.rtmpDialog.rtmpOptions.rtmpStopLink = false;
        vm.rtmpDialog.rtmpOptions.rtmpAudienceLink = false;
        vm.rtmpDialog.rtmpOptions.viewersCount = 0;
        vm.rtmpDialog.rtmpOptions.streamUrl = "";
        vm.rtmpDialog.rtmpOptions.zoomUrl = "";
        if (sessionId) {
          let sessions = vm.myAgenda.filter((item) => {
            return item.SessionId == sessionId;
          });
          if (sessions.length > 0) {
            vm.rtmpDialog.sessionId = sessionId;
            vm.rtmpDialog.session = sessions[0];
            vm.rtmpDialog.rtmpOptions.sessionId = sessionId;
            vm.rtmpDialog.rtmpOptions.uid = vm.userid;
            vm.rtmpDialog.rtmpOptions.event_collectionName =
              vm.event_collectionName;
            if (sessions[0].IsHost) {
              vm.rtmpDialog.rtmpOptions.title = "Welcome Session Host";
            } else if (sessions[0].IsSpeaker) {
              vm.rtmpDialog.rtmpOptions.title = "Welcome Session Speaker";
            } else {
              vm.rtmpDialog.rtmpOptions.title = "Welcome Session Attendee";
            }
            vm.rtmpDialog.rtmpOptions.streamUrl =
              sessions[0].ZoomRTMPMUX_detail.data.playbackUrl;
            vm.rtmpDialog.lastUpdateTimeStamp = new Date().getTime();

            vm.initParticipantsListener(vm.rtmpDialog.sessionId);
          } else {
            flag = false;
          }
        } else {
          flag = false;
        }
      }
      if (flag) {
        if (action == -1) {
          vm.hideLoader();
          vm.rtmpDialog.state = false;
          vm.rtmpDialog.key += 1;
          //vm.rtmpComponent.stopStreaming();
          if (ZoomRTMPParticipantsListener) {
            ZoomRTMPParticipantsListener();
            ZoomRTMPParticipantsListener = null;
          }
          if (vm.rtmpDialog.session.ZoomRTMPListener) {
            vm.rtmpDialog.session.ZoomRTMPListener();
            vm.rtmpDialog.session.ZoomRTMPListener = null;
          }
        } else if (action == 0) {
          vm.ZoomRTMPStatusListener(vm.rtmpDialog.session);
          $(".modal").modal("hide");
          vm.hideLoader();
          vm.rtmpDialog.state = true;
          setTimeout(() => {
            vm.rtmpComponent.startStreaming();
          }, 100);
        } else if (action == 1) {
          //vm.rtmpDialog.state = false;
          let session = vm.rtmpDialog.session;
          if (session) {
            if (session.IsZoomRTMP) {
              if (session.IsZoomRTMP && session.IsHost) {
                window.open(session.Zoom_Detail.start_url, "_blank");
                vm.postLeaderboardAction("SNVW");
              } else if (session.IsSpeaker) {
                var link =
                  session.Zoom_Detail.join_url +
                  "&uname=" +
                  vm.firstName.trim() +
                  "%20" +
                  vm.lastName.trim();
                window.open(link, "_blank");
                vm.postLeaderboardAction("SNVW");
              }
            }
          }
        } else if (action == 2) {
          vm.rtmpDialog.rtmpOptions.startProcessing = true;
          vm.StartRTMPStreaming(vm.rtmpDialog.rtmpOptions.sessionId);
          setTimeout(() => {
            vm.rtmpDialog.rtmpOptions.startProcessing = false;
          }, 2000);
        } else if (action == 3) {
          vm.rtmpDialog.rtmpOptions.stopProcessing = true;
          vm.StopRTMPStreaming(vm.rtmpDialog.sessionId);
          setTimeout(() => {
            vm.rtmpDialog.rtmpOptions.stopProcessing = false;
          }, 2000);
        } else if (action == 4) {
          vm.rtmpDialog.state = false;
          vm.goForInternalPlayer(vm.rtmpDialog.sessionId);
        }
      }
    },
    initParticipantsListener(sessionId) {
      if (ZoomRTMPParticipantsListener) {
        ZoomRTMPParticipantsListener();
        ZoomRTMPParticipantsListener = null;
      }
      if (!ZoomRTMPParticipantsListener) {
        ZoomRTMPParticipantsListener = db
          .collection(vm.event_collectionName)
          .doc("SessionList")
          .collection("Sessions")
          .doc(sessionId)
          .collection("Participances")
          .onSnapshot((querySnapshot) => {
            var viewersCount = 0;
            querySnapshot.forEach((doc) => {
              if (doc.data().IsActive) {
                viewersCount++;
              }
            });
            vm.rtmpDialog.rtmpOptions.viewersCount = viewersCount;
          });
      }
      db.collection(vm.event_collectionName)
        .doc("UserVideoActivity")
        .collection("Session")
        .doc(sessionId)
        .get()
        .then(function (doc) {
          if (doc.exists) {
            let data = doc.data();
            vm.rtmpDialog.rtmpOptions.chatEnabled = data.ChatEnabled
              ? data.ChatEnabled
              : false;
            vm.rtmpDialog.rtmpOptions.qnaEnabled = data.QnAEnabled
              ? data.QnAEnabled
              : false;
            //vm.rtmpDialog.rtmpOptions.attendeeEnabled = data.AttendeeEnabled
            //  ? data.AttendeeEnabled
            //  : false;
          }
        });
    },
    showLoader: function () {
      //this.loaderFlg = true;
      if ($("#divLoading") != null) {
        $("#divLoading").show();
      }
    },
    hideLoader: function () {
      clearTimeout(vm.timerLoader);
      vm.loaderFlg = false;

      if ($("#divLoading") != null) {
        $("#divLoading").hide();
      }
    },
  },
};
</script>
<style>
.client-dialog-exhibitors {
  width: 1000px;
  /*min-height: 600px;
  max-height: 600px;*/
}
.client-dialog-exhibitors .v-sheet.v-card {
  border-radius: 0px !important;
}
.ex-dialog-body {
  /*margin: 20px !important;*/
  height: 530px;
}
.client-dialog-exhibitors .v-tab {
  text-transform: unset !important;
}
.client-dialog-exhibitors .tab-content {
  margin-top: 0px;
}
.client-dialog-exhibitors .tab-content .v-tab {
  margin-bottom: 10px;
}
.client-dialog-exhibitors .v-tab:first-child {
  margin-left: 0px !important;
}
.client-dialog-exhibitors .v-tab {
  padding: 6px !important;
}
.client-dialog-exhibitors .v-tabs.v-tabs--vertical .v-tab {
  padding: 0px !important;
  padding-right: 6px !important;
}
.client-dialog-exhibitors .v-tabs-bar {
  height: 60px !important;
}
.client-dialog-exhibitors .v-tabs.v-tabs--vertical .v-tabs-bar {
  height: unset !important;
}
#btnExAppointmentPopUp {
  color: #fff;
}
.dynamic-chat-button {
  position: fixed;
  z-index: 999;
  right: 3%;
  bottom: 7%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.dynamic-chat-button p {
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  margin: 0 !important;
  color: #fb8d03;
}
.lounge-session-wrap {
  width: 500px;
  position: absolute;
  right: 0;
  bottom: 50%;
  transform: translateY(50%);
  height: 630px;
  overflow-y: auto;
}
@media only screen and (max-width: 1366px) {
  .lounge-session-wrap {
    max-height: 370px !important;
  }
}

</style>
<style scoped>
.full-page-frame {
  height: calc(100vh - 116px) !important;
  width: 100%;
}
.pl-80 {
  padding-left: 80px;
}
</style>



<style scoped>
.speaker-lounge-hld {
  height: 100vh;
  width: 100%;
  background: url("https://firebasestorage.googleapis.com/v0/b/uate2monair.appspot.com/o/OA_UAT_C1591205467009E1591206650065%2FImage%2Fspeaker-lounge.jpg?alt=media")
    no-repeat scroll center center / cover;
}
.lounge-custome-container {
  width: 95%;
  padding: 0 15px;
  margin: 0 auto;
  position: relative;
  height: 100%;
}
.lounge-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 50px 0;
}
.speaker-lounge-left h4 {
  color: #fff;
  font-weight: 700;
  font-size: 26px;
}
.speaker-lounge-left h2 {
  color: #fff;
  margin: 0;
  font-weight: 700;
  font-size: 50px;
  text-transform: uppercase;
}
.speaker-lounge-right ul {
  margin: 0 !important;
  padding: 0 !important;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.speaker-lounge-right ul li {
  display: inline-block;
}
.speaker-lounge-right ul li a {
  display: inline-block;
  color: #fff;
  margin-right: 20px;
  font-weight: 400;
  font-size: 16px;
}
.speaker-lounge-right span {
  height: 55px;
  width: 55px;
  display: block;
  margin: 0 auto;
  border-radius: 50%;
  margin-bottom: 5px;
}
.speaker-lounge-right ul li:first-child a span {
  background: rgba(255, 255, 255, 0.4)
    url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 23.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 48 48' style='enable-background:new 0 0 48 48;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D%0A%3C/style%3E%3Cpath class='st0' d='M37,28.3L37,28.3l0-3.9c0-5.5-3.4-10.2-8.3-12.1c0.3-0.7,0.5-1.5,0.5-2.3c0-2.9-2.4-5.3-5.3-5.3 s-5.3,2.4-5.3,5.3c0,0.8,0.2,1.6,0.5,2.3c-4.8,1.9-8.3,6.6-8.3,12.1v3.9h0c-2.3,0-4.3,1.9-4.3,4.3s1.9,4.3,4.3,4.3H18 c0,0.1,0,0.3,0,0.5c0,3.3,2.7,6,6,6s6-2.7,6-6c0-0.2,0-0.3,0-0.5H37c2.3,0,4.3-1.9,4.3-4.3S39.4,28.3,37,28.3z M21.7,10 c0-1.3,1-2.3,2.3-2.3s2.3,1,2.3,2.3c0,0.6-0.2,1.1-0.6,1.5c-0.6-0.1-1.1-0.1-1.7-0.1s-1.1,0.1-1.7,0.1C21.9,11.1,21.7,10.6,21.7,10z M14,24.4c0-5.5,4.5-10,10-10s10,4.5,10,10v3.9H14V24.4z M27,37.3c0,1.7-1.4,3-3,3s-3-1.4-3-3c0-0.2,0-0.3,0-0.5H27 C27,37,27,37.1,27,37.3z M37,33.8H11c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3H37c0.7,0,1.3,0.6,1.3,1.3S37.7,33.8,37,33.8z'/%3E%3C/svg%3E%0A")
    no-repeat center center / 35px;
}
.speaker-lounge-right ul li:nth-child(2) a span {
  background: rgba(255, 255, 255, 0.4)
    url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 23.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 48 48' style='enable-background:new 0 0 48 48;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D%0A%3C/style%3E%3Cpath class='st0' d='M42.3,36.9c-1.9-6.6-7-11.7-13.2-13.5c3-1.9,5-5.2,5-9c0-5.9-4.8-10.6-10.6-10.6S12.8,8.5,12.8,14.4 c0,3.9,2.2,7.4,5.4,9.2c-5.6,1.9-10.2,6.5-12.3,12.7l0,0c-0.2,0.6-0.4,1.3-0.4,2c0,3.3,2.7,5.9,5.9,5.9h25.1c3.3,0,5.9-2.7,5.9-5.9 C42.5,37.9,42.4,37.5,42.3,36.9z M15.8,14.4c0-4.2,3.4-7.6,7.6-7.6s7.6,3.4,7.6,7.6s-3.4,7.6-7.6,7.6S15.8,18.6,15.8,14.4z M36.6,41.2H11.4c-1.6,0-2.9-1.3-2.9-2.9c0-0.4,0.1-0.7,0.2-1l0.1-0.2c2.3-6.8,8.4-11.4,15.2-11.4c7.2,0,13.4,4.9,15.4,12 c0.1,0.2,0.1,0.4,0.1,0.6C39.5,39.9,38.2,41.2,36.6,41.2z'/%3E%3C/svg%3E")
    no-repeat center center / 35px;
}
.speaker-lounge-right ul li:last-child a span {
  background: rgba(255, 255, 255, 0.4)
    url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 23.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 80 48' style='enable-background:new 0 0 80 48;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D%0A%3C/style%3E%3Cpath class='st0' d='M74.6,35.3c0-5.7-3.3-10.6-8.1-12.7c1.7-1.5,2.8-3.6,2.8-6c0-4.4-3.5-7.9-7.9-7.9s-7.9,3.5-7.9,7.9 c0,2.4,1.1,4.6,2.8,6c-1.8,0.8-3.5,2-4.8,3.6c-1.8-1.3-3.7-2.2-5.8-2.8c3-1.9,5-5.2,5-9c0-5.9-4.8-10.6-10.6-10.6 c-5.9,0-10.6,4.8-10.6,10.6c0,3.9,2.2,7.4,5.4,9.2c-2.1,0.7-4,1.8-5.7,3.2c-1.4-1.8-3.2-3.2-5.3-4.1c1.7-1.5,2.8-3.6,2.8-6 c0-4.4-3.5-7.9-7.9-7.9s-7.9,3.5-7.9,7.9c0,2.4,1.1,4.5,2.8,6c-4.8,2.1-8.1,7-8.1,12.7v1.5h17c-0.1,0.5-0.2,1-0.2,1.5 c0,3.3,2.7,5.9,5.9,5.9h25.1c3.3,0,5.9-2.7,5.9-5.9c0-0.4,0-0.8-0.2-1.4c0,0,0-0.1,0-0.1h15.8V35.3z M56.5,16.7 c0-2.7,2.2-4.9,4.9-4.9s4.9,2.2,4.9,4.9s-2.2,4.9-4.9,4.9S56.5,19.4,56.5,16.7z M32.4,14.4c0-4.2,3.4-7.6,7.6-7.6s7.6,3.4,7.6,7.6 s-3.4,7.6-7.6,7.6S32.4,18.6,32.4,14.4z M13.7,16.7c0-2.7,2.2-4.9,4.9-4.9s4.9,2.2,4.9,4.9s-2.2,4.9-4.9,4.9S13.7,19.4,13.7,16.7z M18.6,24.6c3.3,0,6.2,1.6,8.2,4.3c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2,0.2-0.4,0.5-0.6,0.7c-0.1,0.2-0.3,0.4-0.4,0.6 c-0.1,0.2-0.3,0.4-0.4,0.6c-0.2,0.3-0.4,0.5-0.5,0.8c-0.1,0.1-0.2,0.3-0.3,0.4c-0.2,0.3-0.4,0.6-0.5,0.9c-0.1,0.1-0.1,0.3-0.2,0.4 c-0.1,0.1-0.1,0.2-0.2,0.3h-15C9.1,28.6,13.4,24.6,18.6,24.6z M53.1,41.2H28c-1.6,0-2.9-1.3-2.9-2.9c0-0.4,0.1-0.7,0.2-1l0.1-0.2 c0.1-0.4,0.3-0.8,0.4-1.2c0.2-0.5,0.5-1,0.7-1.5c0-0.1,0.1-0.2,0.1-0.2c0.2-0.4,0.5-0.8,0.8-1.3c0-0.1,0.1-0.1,0.1-0.2 c0.6-0.9,1.4-1.8,2.2-2.6l0.1-0.1c2.9-2.7,6.7-4.3,10.7-4.3c3.5,0,6.7,1.1,9.3,3.1l0.8,0.7c2,1.7,3.6,3.9,4.6,6.4l0.3,0.7 c0.1,0.4,0.3,0.7,0.4,1.1c0.1,0.2,0.1,0.4,0.1,0.6C56.1,39.9,54.8,41.2,53.1,41.2z M57.7,33.8c-0.2-0.5-0.5-1-0.8-1.5 c0,0,0-0.1-0.1-0.1c-0.3-0.4-0.5-0.8-0.8-1.2c-0.1-0.2-0.2-0.3-0.4-0.5c-0.2-0.2-0.4-0.5-0.6-0.7c-0.2-0.2-0.4-0.5-0.6-0.7 c-0.1-0.1-0.2-0.3-0.4-0.4c-0.1-0.1-0.2-0.3-0.4-0.4c1.9-2.3,4.7-3.6,7.7-3.6c5.2,0,9.5,4,10.2,9.3H57.7z'/%3E%3C/svg%3E")
    no-repeat center center / 35px;
}
.lounge-session-left {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  flex: 100% 0 0;
  flex-direction: column;
}
.single-lounge-session {
  width: 100%;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.6);
  padding: 10px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.lounge-session-time p {
  margin: 0 !important;
  font-size: 14px;
  color: #000;
  font-weight: 400;
  padding-left: 22px;
  background: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='%23b7b7b7' d='M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12S17.5 2 12 2M17 13H11V7H12.5V11.5H17V13Z' /%3E%3C/svg%3E")
    no-repeat left center / 16px;
}
/* .lounge-session-details {
  padding-left: 10px;
} */
.lounge-session-details span.lounge-session-status {
  display: inline-block;
  position: relative;
  padding-left: 22px;
}
.lounge-session-details span.lounge-session-status:before {
  content: "";
  position: absolute;
  height: 14px;
  width: 14px;
  background: #b7b7b7;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 50%;
}
.lounge-session-details span.lounge-session-status.end:before {
  background: #b7b7b7;
}
.lounge-session-details span.lounge-session-status.upcoming:before {
  background: #fdc62b;
}
.lounge-session-details span.lounge-session-status.live:before {
  background: #1e932e;
}
.lounge-session-action button {
  border: none;
  padding: 8px 25px;
  border-radius: 5px;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  background: #1a73e8;
  white-space: nowrap;
}
.lounge-session-action button.disabled {
  opacity: 0.4;
  cursor: unset;
}
.lounge-session-time {
  width: 100%;
  flex: 100% 0 0;
}
/* .lounge-session-details {
  width: 79%;
} */
.speaker-guide-btn {
  position: absolute;
  left: 0;
  bottom: 30%;
  padding-left: 15px;
}

.speaker-guide-btn a {
  height: 50px !important;
  min-width: 200px !important;
  display: inline-flex !important;
  background: #1a73e8;
  border-radius: 5px;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 10px rgb(113 166 234);
  font-weight: 600;
  font-size: 16px;
}
.lounge-session-list-wrap h3 {
  color: #fff;
  text-shadow: 0 0 2px #000, 0 0 5px #1a73e8, 0 0 2px #000;
  font-weight: 700;
  font-size: 30px;
}




</style>